function escapeQuizHtml(value) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function formatQuizProductTitles() {
  document.querySelectorAll('#quiz-kit-content h3').forEach((heading) => {
    if (heading.dataset.formatted === 'true') return;

    const [productTitle, variantTitle] = heading.textContent.trim().split(/ - (.+)/);

    if (!variantTitle) return;

    heading.innerHTML = `<span class="quiz-product-title">${escapeQuizHtml(productTitle)}</span><span class="quiz-product-variant">${variantTitle
      .split(/\s*\/\s*/)
      .map((part) => `<span>${escapeQuizHtml(part)}</span>`)
      .join('')}</span>`;

    heading.dataset.formatted = 'true';
  });
}

formatQuizProductTitles();

const quizObserver22 = new MutationObserver(formatQuizProductTitles);

quizObserver22.observe(document.body, {
  childList: true,
  subtree: true
});
